import {
    GET_USER_PROFILES_FAILURE,
    GET_USER_PROFILES_REQUEST,
    GET_USER_PROFILES_SUCCESS
} from "../actions/actionTypes";

const initState = {
    isFetching: false,
    userProfiles: [],
    totalPages: 0,
    currentPage: 0,
};

const userProfilesReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_USER_PROFILES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_USER_PROFILES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                userProfiles: action.response.resourceList,
                totalPages: action.response.totalPages,
                currentPage: action.response.currentPage,
            });
        case GET_USER_PROFILES_FAILURE:
            return initState;
        default:
            return state;
    }
};

export default userProfilesReducer;
